import gql from 'graphql-tag';

const PARTYMASTER = gql`
query getParties($page: Int, $limit: Int, $filter: String, $sort: partySort){
  getParties(page:$page, limit:$limit, filter:$filter, sort:$sort){
    count
    data{
      id
      partyId
      partyName
      partyType
      street
      road
      city
      country
      ownerName
      contactName
      restricted
      chequeClear
      pdcAllow
      zip
      mobile1
      mobile2
      phone1
      phone2
      intercom
      fax
      invMsg
      joinDate
      refName
      termId{
        id
        termName
      }
      leaveDate
      courierName
      shipmentName
      cif
      intPer
      openBal
      balType
      currency
      crLimit
      vatNo
      panNo
      tanNo
      cstNo
      gstNo
      giaAcNo
      ibanNo
      clearCode
      swiftCode
      branchName
      chipsNo
      fedwireNo
      location
      portdisch
      finalDest
      brokerPer
      commisionPer
      printName
      email
      acGroup
      acGroupName
      salesmanId
      salesmanName
      brokerId
      brokerName
      isActive
      createdBy
      createdAt
      updatedAt
    }
  }
}
`;
export const ALLPARTYMASTERDETAILS = gql`
query getAllParties{
  getAllParties{
    id
    partyName
    partyType
    email
  }
} 
`;

export const LabPARTYMASTERDETAILS = gql`
query getLabParties{
  getLabParties{
    id
    partyName
    partyType
    email
  }
}
`;
export const ALLBROKERDATA = gql`
query getSelectedParties($type: String!){
  getSelectedParties(type:$type){
    id
    partyName
  }
}
`;

export default PARTYMASTER

